import { find } from "../utils/dom"

export default function () {
    const menuHome = find("[js-page='menu']")
    if (!menuHome) return

    console.log('Menu');
		const largura = window.innerWidth;

		if (largura > 1024) {
			window.addEventListener('scroll', () => {
				if (window.scrollY > 50) {
					menuHome.classList.add('menu-effect-scroll');
				} else {
					menuHome.classList.remove('menu-effect-scroll');
				}
			});
		}


	const menuToggle = document.querySelectorAll('.menu-toggle');
	const menu = document.querySelector('.menu');
	const menuGlass = document.querySelector('.menu-glass')

	menuToggle.forEach(menuToggle=>{
			menuToggle.addEventListener('click', () => {
				menuGlass.classList.toggle('hidden')
				menu.classList.toggle('open');
			});
	})

	const dropItensMobile = () =>{
		const dropToggleMobile = document.querySelectorAll('.item-menu-toggle')
	
		dropToggleMobile?.forEach(itemDrop=>{
				itemDrop?.addEventListener('click', (e)=>{
						const svgItem = itemDrop.querySelector('svg')
						const itensDrop = itemDrop.querySelector('.itens-menu-toogle-content')
						svgItem.classList.toggle('rotate-180')
						itensDrop.classList.toggle('hidden')
						console.log('Item Drop', svgItem, itensDrop);
				})
		})
	}

	dropItensMobile()
}